<template>
  <div>
    <app-loading-section :loading="isLoading">
      <h4 class="label text-uppercase">Steps</h4>

      <template v-if="steps.length">
        <follow-up-view-info-step
          v-for="step in steps"
          :key="step.id"
          :step="step"
        ></follow-up-view-info-step>
      </template>
      <p v-else class="my-100">There are no steps in the follow up</p>

      <!-- Dates -->
      <div class="columns mt-100">
        <div class="column">
          <p class="label text-uppercase">Started</p>
          <p>{{ formatDate(followUp.started_at) }}</p>
        </div>
        <div v-if="isPaused" class="column">
          <p class="label text-uppercase">Paused</p>
          <p>{{ formatDate(followUp.paused_at) }}</p>
        </div>
        <div v-if="isComplete || isCancelled" class="column">
          <p class="label text-uppercase">{{ isComplete ? "Completed" : "Cancelled" }}</p>
          <p>{{ formatDate(followUp.completed_at) }}</p>
        </div>
      </div>
    </app-loading-section>
  </div>
</template>

<script>
import {ENUMS} from "../../../services/enums";
import FollowUpViewInfoStep from "./FollowUpViewInfoStep";
import dates from "../../../services/dates";
import api from "../../../api";

export default {
  name: "FollowUpViewInfo",
  components: {FollowUpViewInfoStep},
  props: {
    followUp: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLoading: true,
      steps: [],
    }
  },
  mounted() {
    this.getSteps()
  },
  computed: {
    isActive() {
      return this.followUp.status === ENUMS.FollowUpSequenceStatusEnum.Active.value;
    },
    isPaused() {
      return this.followUp.status === ENUMS.FollowUpSequenceStatusEnum.Paused.value;
    },
    isCancelled() {
      return this.followUp.status === ENUMS.FollowUpSequenceStatusEnum.Canceled.value;
    },
    isComplete() {
      return this.followUp.status === ENUMS.FollowUpSequenceStatusEnum.Complete.value;
    },
  },
  methods: {
    getSteps() {
      this.isLoading = true
      api.followUp.getSteps(this.followUp.id)
        .then(res => {
          this.steps = res.data;
        })
        .finally(() => this.isLoading = false);
    },
    formatDate(date) {
      return dates.formatAsDate(date) + " @ " + dates.formatAsTime(date);
    },
  },
};
</script>
